var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0269 6.24833L9.45689 1.66833C8.36689 0.57833 6.60689 0.57833 5.52689 1.66833L0.946895 6.24833C-0.143106 7.33833 -0.143106 9.09833 0.946895 10.1783L5.51689 14.7483C6.60689 15.8383 8.36689 15.8383 9.44689 14.7483L14.0169 10.1783C15.1069 9.08833 15.1069 7.32833 14.0169 6.24833H14.0269ZM10.0069 10.0783C10.0069 10.4383 9.71689 10.7283 9.35689 10.7283H5.61689C5.25689 10.7283 4.96689 10.4383 4.96689 10.0783V6.33833C4.96689 5.97833 5.25689 5.68833 5.61689 5.68833H9.35689C9.71689 5.68833 10.0069 5.97833 10.0069 6.33833V10.0783Z",
    fill: "#74D415"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.7,
    height: 14.7,
    fill: "white",
    transform: "translate(0.136719 0.858398)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.0a7ea19f732f06a02edcb33ee10dc81d.svg";
export { ForwardRef as ReactComponent };